import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import MyTextInput from "../../app/common/form/MyTextInput";
import { Button, Label } from "semantic-ui-react";
import ModalWrapper from "../../app/common/modals/ModalWrapper";
import { otpValidation } from "../../app/apiRequest/signupService";
import { useDispatch, useSelector } from "react-redux";

export default function VerificationForm() {
  const dispatch = useDispatch();
  const { user, from } = useSelector((state) => state.modal.modalProps);

  return (
    <ModalWrapper
      size="small"
      header={
        from === "login"
          ? "Your username is not verified, verify token"
          : "Verify OTP"
      }
    >
      <Formik
        initialValues={{ token: "" }}
        validationSchema={Yup.object({
          token: Yup.string().required(),
        })}
        onSubmit={async (values, { setSubmitting, setErrors }) => {
          try {
            dispatch(otpValidation({ user: user, token: values.token }));
          } catch (error) {
            setErrors({ auth: "Verification failed.." });
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting, isValid, dirty, errors }) => (
          <Form className="ui form">
            <p>*it may take 1-2 minutes</p>
            <MyTextInput
              name="token"
              placeholder="Enter OTP"
              style={{ marginBottom: 20 }}
            />
            {errors.auth && (
              <Label
                basic
                color="red"
                style={{ marginBottom: 20 }}
                content={errors.auth}
              />
            )}
            <Button
              loading={isSubmitting}
              disabled={!isValid || !dirty || isSubmitting}
              type="submit"
              fluid
              size="large"
              color="teal"
              content="Verify"
            />
          </Form>
        )}
      </Formik>
    </ModalWrapper>
  );
}
